// Mirrors the vegetation-legend labels shown as 3D <TextFeld> in HolzarbeitTimeMachine.jsx,
// keyed by splinePoint (1-12), for display in the WaypointArrows sidebar.
const holzarbeitZeitmaschineTitel = {
  2: {
    de: "Kiefer und Birke",
    en: "Pine and birch",
  },
  3: {
    de: "Kiefer und Birke",
    en: "Pine and birch",
  },
  4: {
    de: "Kiefer, Birke, Fichte und Buche",
    en: "Pine, birch, spruce and beech",
  },
  6: {
    de: "Karstlandschaft, kaum Vegetation, Bäume verschwinden",
    en: "Karst landscape, hardly any vegetation, trees disappear.",
  },
  7: {
    de: "Karstlandschaft, kaum Vegetation, Bäume verschwinden",
    en: "Karst landscape, hardly any vegetation, trees disappear.",
  },
  8: {
    de: "Karstlandschaft, kaum Vegetation, Bäume verschwinden",
    en: "Karst landscape, hardly any vegetation, trees disappear.",
  },
  9: {
    de: "Karstlandschaft, kaum Vegetation, Bäume verschwinden",
    en: "Karst landscape, hardly any vegetation, trees disappear.",
  },
  10: {
    de: "Aufforstung mit Fichten",
    en: "Reforestation with spruce trees",
  },
  11: {
    de: "Aufforstung mit Fichten",
    en: "Reforestation with spruce trees",
  },
  12: {
    de: "Aufforstung mit Fichten",
    en: "Reforestation with spruce trees",
  },
};

export default holzarbeitZeitmaschineTitel;
